import { QRCodeView } from 'browser/components/atomic-elements/atoms/qrcode-view/qrcode-view'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
export const QRCodeField = LabelFieldFactory({ InputComponent: QRCodeView })
